<template>
  <div class="dialog-content">

    <el-dialog title="运动员选择" :visible.sync="isShow" @close="onClose">
      <el-input placeholder="请输关键字搜索" v-model="keywords" @input="onSearch"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
      <div style="margin: 10px 0">可选列表</div>
      <div class="picker-cell-group" v-if="options.length>0">
        <div class="picker-cell" v-for="(item, index) in options" :v-if="index < limit">
          <el-checkbox :value="item.checked"  @change="toggle(item)">{{item.name}}({{(item.sex==1? '男':'女')+' '+item.num}})</el-checkbox>
        </div>
      </div>
      <div v-else>
        没有记录...
      </div>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="download">导入模版下载</el-button>  -->
        <!-- <van-uploader
            accept=".xls,.xlsx"
            :after-read="readFile"
        >
          <el-button 
              size="normal">批量导入
          </el-button>
        </van-uploader> -->
        <el-button @click="memberAdd">新增运动员</el-button>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </el-dialog>


      <van-popup :close-on-click-overlay="false" v-model="showLoading">
        <div class="circle-div" style="text-align: center;"> 
            <el-progress :percentage="progress"></el-progress>
          <van-button
              style="width: 3rem; margin-top: 10px"
              size="normal" round>上传中
          </van-button>
        </div>
        <div>
        </div>

      </van-popup>

    <el-dialog title="新增运动员" class="dialog-content" :visible.sync="addShow" @close="addShow = false">
      <el-form
          :model="formData"
          ref="ruleForm"
          :rules="rules"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input
                  type="text"
                  placeholder="请输入姓名"
                  v-model="formData.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="type">
              <el-radio-group v-model="formData.cardtype">
                <el-radio :label="1">身份证</el-radio>
                <el-radio :label="2">护照</el-radio>
                <el-radio :label="3">其他身份证明</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="this.formData.cardtype != 1">
          <el-col :span="12">
            <el-form-item label="生日" prop="birthday">
              <!--              <el-input-->
              <!--                  type="text"-->
              <!--                  placeholder="请选择生日"-->
              <!--                  v-model="formData.birthday"-->
              <!--              ></el-input>-->
              <el-date-picker
                  v-model="formData.birthday"
                  type="date"
                  :picker-options="pickerOptions"
                  placeholder="请选择生日">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="formData.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="num" v-if="formData.cardtype==1">
              <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="formData.num"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.cardtype!=1">
            <el-form-item label="证件号码" prop="huzhao">
              <el-input
                  type="text"
                  placeholder="请输入证件号码"
                  v-model="formData.huzhao"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="监护人姓名" prop="jianhuname">
              <el-input
                  type="text"
                  placeholder="请输入监护人姓名"
                  v-model="formData.jianhuname"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="监护人证件号码" prop="jianhunum">
              <el-input
                  type="text"
                  placeholder="请输入监护人证件号码"
                  v-model="formData.jianhunum"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="监护人手机" prop="jianhuphone">
              <el-input
                  type="text"
                  placeholder="请输入监护人证件手机"
                  v-model="formData.jianhuphone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>



    <van-dialog v-model="showError" title="批量导入错误信息">
      <van-cell-group>
        <van-cell :title="item" :key="index" v-for="(item,index) in errorMsg"/>
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import validator from "../../utils/validator";
import { Toast } from 'vant';
import XLSX from "xlsx";

export default {
  name: "JiaolianPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },

    danweiId: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 1
    },

    defaultValue: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      isShow: false,
      addShow:false,
      showLoading:false,
      progress:0,
      user_id:0,
      showError:false,
      errorMsg:[],
      showDate: false,
      result: [],
      list:[],
      keywords: "",
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker:false,
      numTypeColumns: ['身份证', '护照','其他身份证明'],
      actions:[
        { name: '隐藏' },
        { name: '认证' },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        jianhuname: [{ required: true, message: "请输入监护人姓名", trigger: "blur" }],
        namekey: [{ required: true, message: "请选择省市", trigger: "blur" }],
        area: [{ required: true, message: "请选择地区", trigger: "blur" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        nickname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        num: [
          { required: true, message: "请输入正确的身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        jianhunum: [
          { required: true, message: "请输入正确的身份证号", trigger: "blur" },
          { validator: validator.idCard, trigger: "blur" },
        ],
        huzhao: [
          { required: true, message: "证件号码不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        jianhuphone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
          { validator: validator.phone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入正确的邮箱", trigger: "blur" },
          { validator: validator.email, trigger: "blur" },
        ],
      },
      formData: {
        name: '',
        num: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: 1,
        numTypeName: '身份证',
        jianhuname: '',
        jianhunum: '',
        jianhuphone: '',
      },
      formData2: {
        user_id: 0,
        name: '',
        num: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: 1,
        numTypeName: '身份证',
        jianhuname: '',
        jianhunum: '',
        jianhuphone: '',
      },
      saveLoading:false,
    };
  },
  computed:{
    options(){
      let that = this;
      this.list.map((item,index) =>{
        if(that.resultIds.indexOf(item.num) ==-1){
          item.checked = false;
        }else{
          item.checked = true;
        }
      })

      return [...this.list];
    },
    resultIds(){
      return this.result.map((item,index) =>{
        return item.num
      })
    },

    showBirthday(){
      return this.formData.cardtype !=1 ;
    },
    showSex(){
      return this.formData.cardtype !=1 ;
    },
  },
  mounted() {
  },
  watch: {
    show(value) {
      this.isShow = value;
      if(value){
        this.onSearch();
        this.result = [...this.defaultValue];
      }
    },
    result(value){
      this.$emit("onChange",value);
    },

  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },

    toggle(item) {
      console.log('toggle',item.checked);
      if(!item.checked){
        //选中
        if(this.limit ==1 ){
          //单选
          this.options.map(item=>{
            item.checked = false;
          })
          this.result = [];
        }else{
          //多选
          if(this.result.length >= this.limit ){
            this.$message.info('最多不能超过'+(this.limit)+'个');
            return ;
          }

        }

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        this.result.push(item);
      }else{
        //pen
        this.result = this.result.filter(val =>{
          return val.id != item.id
        });
      }
    },
    onSearch() {
      let that = this;
      that.$api.get(
          "/api/yundongyuan/yundongyuanOptions",
          { keywords: this.keywords,danwei_id:that.danweiId },
          res => {
            that.list = [...res.data];
          }
      );


      that.$api.get('/api/user/userPage', {}, (res) => { 
        that.user_id = res.data.id;
      }, (res) => { 
        // Toast(res.msg)
      });
    },

    onConfirm() {
      let that = this;
      console.log(that.result);
      that.$emit("onConfirm", that.result);
      that.isShow = false;
    },

    memberAdd(){
      this.addShow = true;
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      console.log(that.formData)
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.saveLoading = true;
          that.$api.post("/api/yundongyuan/add", that.formData, (res) => {
            that.saveLoading = false;
            that.addShow = false;
            that.onSearch();
            that.formData = {
              name: '',
              num: '',
              huzhao: '',
              cardtype: 1,
              birthday: '',
              sex: 1,
              numTypeName: '身份证',
              jianhuname: '',
              jianhunum: '',
              jianhuphone: '',
            };
          }, (rs) => {
            that.$message.error(rs.msg)
            that.saveLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submit(){

    },
    download(){
      window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/%E8%BF%90%E5%8A%A8%E5%91%98%E4%BF%A1%E6%81%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx', '_blank');
    },
    onNumTypeConfirm(value, index){
      this.formData.numTypeName = value;
      this.formData.cardtype = index+1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo){
      console.log('failed', errorInfo);
    },


    readFile(evt) {
      console.log('------readFile------', evt)
      var that = this;
      that.errorMsg = []
      that.index = 0

      let files = {0: evt.file}

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表
          var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

          if (that.startNum) {
            list = list.splice(that.startNum, list.length)
          }

          that.listData = list
          // let listData = list.filter(row => {
          //   return row.hasOwnProperty("__EMPTY");
          // })
          console.log('onGetData', list)

          // todo 增加进度条显示 并上传数据

          that.formatData()

        } catch (e) {
          console.log(e)
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },


    formatData() {
      let that = this
      that.showLoading = true
      // that.listData.map((row) => {
        that.addRow()
        // return ;
      // })
    },

    addRow() {
      // return ;
      let that = this
      let row  =  that.listData[that.index];
      console.log(row);
      that.formData2.name = row['姓名']
      switch (row['证件类型（身份证，护照，其他）']) {
        case '身份证':
          that.formData2.cardtype = 1
          that.formData2.num = row['证件号']
          break;
        case '护照':
          that.formData2.cardtype = 2
          that.formData2.huzhao = row['证件号']
          that.formData2.birthday = row['生日（1997-01-01）'] ? row['生日（1997-01-01）'] : ''
          that.formData2.sex = row['性别（男，女）'] ? (row['性别（男，女）'] === '男' ? 1 : 2) : ''
          break;
        case '其他':
          that.formData2.cardtype = 3
          that.formData2.huzhao = row['证件号']
          that.formData2.birthday = row['生日（1997-01-01）'] ? row['生日（1997-01-01）'] : ''
          that.formData2.sex = row['性别（男，女）'] ? (row['性别（男，女）'] === '男' ? 1 : 2) : ''
          break;
      }
      that.formData2.jianhuname = row['监护人姓名'] ? row['监护人姓名'] : ''
      that.formData2.jianhuphone = row['监护人手机'] ? row['监护人手机'] : ''
      that.formData2.jianhunum = row['监护人证件号'] ? row['监护人证件号'] : ''
      that.formData2.user_id = that.user_id


      console.log(that.formData2)
      // return ;
      that.yundongyuanAddAll()
    },

    yundongyuanAddAll() {
      let that = this
      that.$api.post('/api/yundongyuan/addAll', that.formData2, (res) => {
        // that.onRefresh();
        that.formData2 = {
          name: '',
          num: '',
          huzhao: '',
          cardtype: 1,
          birthday: '',
          sex: 1,
          numTypeName: '身份证',
          jianhuname: '',
          jianhunum: '',
          jianhuphone: '',
        }; 
        that.getProgress()
        that.addRow();
      }, (res) => {
        if (res.code === 600) {
          that.errorMsg.push(that.formData2.name +' '+res.msg)
        } 
        that.getProgress()
        that.addRow();
      })
    },

    getProgress() {
      let that = this
      that.index ++; 

      let index = that.index,
          list = that.listData

      console.log(that.errorMsg, index, list.length)

      that.progress = parseInt((index / list.length) * 100)
      if (index >= list.length) {
        that.showLoading = false
        that.onSearch()

        if (that.errorMsg.length > 0) {
          // 唤起弹框
          that.showError = true

        } else {
          that.$message.success('批量导入成功')
        }
      }
    },

  }
};
</script>

<style scoped>
.contain {
  position: relative;
}
.picker-cell-group {
  margin-top: 10px;
}

.picker-cell {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// YundongyuanPicker.vue?34d3757e